module.exports = __webpack_public_path__ + "static/media/innlink_logo.2512e282.svg";